import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-clear-history-dialog',
  templateUrl: './clear-history-dialog.component.html',
  styleUrls: ['./clear-history-dialog.component.scss'],
})
export class ClearHistoryDialog {
  constructor(
    public dialogRef: MatDialogRef<ClearHistoryDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
}
